import React, { Component } from 'react';
import { images } from '../../settings';

import './CardSliderFotos.scss';

class CardSliderFotos extends Component {
  constructor(props) {
    super(props);

    this.state = {
      maxSlides: 0,
      urlImagens: '',
      slides: [],
      color: 'blue',
      cActive: 0,
    };
    this.images = images;
  }

  componentWillMount = () => {
    const { items, color, url } = this.props;
    if (items) {
      this.setState({
        maxSlides: items.length >= 5 ? 5 : 3,
        slides: items,
        urlImagens: url,
        color: color,
      });
    }
  };

  componentDidMount = () => {};

  componentWillUnmount = () => {};

  renderSlider = slides => {
    const { cActive, urlImagens, maxSlides } = this.state;
    return (
      <div className="card-slider-fotos--imagens">
        {slides.map((item, index) => {
          let itemClass = [
            index == cActive ? 'card-slider-fotos--imagem-ativa' : '',
            cActive == slides.length - 1 && index == 0
              ? 'card-slider-fotos--imagem-ativa-next'
              : cActive + 1 == index
              ? 'card-slider-fotos--imagem-ativa-next'
              : '',
            cActive == 0 && index == slides.length - 1
              ? 'card-slider-fotos--imagem-ativa-prev'
              : cActive - 1 == index
              ? 'card-slider-fotos--imagem-ativa-prev'
              : '',
            maxSlides == 5 && index == slides.length - 2 && cActive == 0
              ? 'card-slider-fotos--imagem-ativa-prev-prev'
              : maxSlides == 5 && index == slides.length - 1 && cActive == 1
              ? 'card-slider-fotos--imagem-ativa-prev-prev'
              : maxSlides == 5 && cActive - 2 == index
              ? 'card-slider-fotos--imagem-ativa-prev-prev'
              : '',
            maxSlides == 5 && index == 1 && cActive == slides.length - 1
              ? 'card-slider-fotos--imagem-ativa-next-next'
              : maxSlides == 5 && index == 0 && cActive == slides.length - 2
              ? 'card-slider-fotos--imagem-ativa-next-next'
              : maxSlides == 5 && cActive + 2 == index
              ? 'card-slider-fotos--imagem-ativa-next-next'
              : '',
          ];
          return (
            <div key={index} className={itemClass.join(' ')}>
              <span className={index == cActive ? 'card-slider-fotos--cargo active' : 'card-slider-fotos--cargo'}>
                {item.cargo}
              </span>
              <img src={urlImagens + item.imagem + '.png'} />
            </div>
          );
        })}
      </div>
    );
  };

  changeSliderPrev(item) {
    const newIndex = Object.assign({}, this.state);
    newIndex[`cActive`] = newIndex[`cActive`] - 1 < 0 ? newIndex[`slides`].length - 1 : item - 1;
    this.setState(newIndex);
  }

  changeSliderNext(item) {
    const newIndex = Object.assign({}, this.state);
    newIndex[`cActive`] = newIndex[`cActive`] + 1 > newIndex[`slides`].length - 1 ? 0 : item + 1;
    this.setState(newIndex);
  }

  render = () => {
    const { slides, cActive, color } = this.state;
    const sliderClasses = color ? ['card-slider-fotos', `cardslider--${color}`] : ['card-slider-fotos'];

    return (
      <div className={sliderClasses.join(' ')}>
        {this.renderSlider(slides)}
        <div className="card-slider-fotos--info">
          <button className="card-slider-fotos--btn-esq" onClick={() => this.changeSliderPrev(cActive)}></button>
          <button className="card-slider-fotos--btn-dir" onClick={() => this.changeSliderNext(cActive)}></button>
          <h3>{slides[cActive].nome}</h3>
          <p className="card-slider-fotos--descricao">{slides[cActive].descricao}</p>
          <span className="card-slider-fotos--separacao"></span>
          <p className="card-slider-fotos--ativo">
            <span>{cActive + 1 < 10 ? '0' + (cActive + 1) : cActive + 1}</span>/
            {slides.length < 10 ? '0' + slides.length : slides.length}
          </p>
        </div>
      </div>
    );
  };
}

export { CardSliderFotos };
